import { connect } from 'react-redux';
import noop from 'lodash/noop';

import {
    GA_CANCEL_MODAL_BUTTON_DIMENSION,
    GA_SALES_STATUS_ACTION_POSTPONE_STARTED,
    GA_SALES_STATUS_CATEGORY_EVENT_STATUS,
} from '@eb/event-create-analytics';
import { constants, event } from '@eb/event-create-publish-utils';
import { getGuidedChecklistVariant } from '@eb/variants';
import { getIsMarketingToolsExperimentEnabled } from '@eb/feature-flags';
import { setWindowLocation } from 'js-utils/http';
import { trackAnalyticsEvent } from '@eb/site-analytics';

import { OrganizerHeader } from '../components';

const {
    DISPLAY_SALES_STATUS_CANCELLED,
    DISPLAY_SALES_STATUS_POSTPONED,
} = constants;

const {
    connectUtils: {
        dispatchPublishEvent,
        dispatchUnpublishEvent,
        dispatchCancelEvent,
        dispatchDeleteEvent,
        dispatchCancelSchedulePublish,
        changeSalesStatus,
        getPostponeStartButtonNameDimension,
    },
    actions: { clearEventStatusError, navigateAfterClick },
    utils: { getEventStatusButtonType },
} = event;

const getEventActionError = (state) => state.eventStatus?.statusError?.error;

export const mapStateToProps = (state, eventData, eventId) => ({
    eventActionError: getEventActionError(state),
    eventStatusButtonType: getEventStatusButtonType(eventData),
    guidedChecklistVariant: getGuidedChecklistVariant(state),
    isManagePage: true,
    isMarketingToolsExperimentEnabled: getIsMarketingToolsExperimentEnabled(
        state,
    ),
    trackGASelectPostponeStatusEvent: (
        buttonDimension = GA_CANCEL_MODAL_BUTTON_DIMENSION,
    ) =>
        trackAnalyticsEvent({
            category: GA_SALES_STATUS_CATEGORY_EVENT_STATUS,
            action: GA_SALES_STATUS_ACTION_POSTPONE_STARTED,
            dimensions: {
                eventId,
                nameOfButton: getPostponeStartButtonNameDimension(
                    buttonDimension,
                ),
            },
        }),
    navigateToUrl: setWindowLocation,
});

const mapDispatchToProps = (dispatch, eventId) => ({
    onPublishClick: (publishClick) =>
        dispatchPublishEvent(dispatch, { ...publishClick, eventId }),
    onUnpublishClick: () =>
        dispatchUnpublishEvent(dispatch, eventId).then(() =>
            setWindowLocation(`/myevent?eid=${eventId}`),
        ),
    onCancelClick: () =>
        dispatchCancelEvent(dispatch, eventId).then(() =>
            dispatch(
                navigateAfterClick(eventId, DISPLAY_SALES_STATUS_CANCELLED),
            ),
        ),
    onPostponeClick: () =>
        dispatch(
            changeSalesStatus(
                eventId,
                {
                    statusCode: DISPLAY_SALES_STATUS_POSTPONED,
                    customMessage: '',
                },
                GA_CANCEL_MODAL_BUTTON_DIMENSION,
            ),
        )
            .then(() =>
                dispatch(
                    navigateAfterClick(eventId, DISPLAY_SALES_STATUS_POSTPONED),
                ),
            )
            .catch(noop),
    onDeleteClick: () => dispatchDeleteEvent(dispatch, eventId),
    onClearError: () => dispatch(clearEventStatusError()),

    onCancelSchedulePublishClick: () =>
        dispatchCancelSchedulePublish(dispatch, eventId),
});

const getConnectedOrganizerHeader = (eventId, eventData) =>
    connect(
        (state) => mapStateToProps(state, eventData, eventId),
        (dispatch) => mapDispatchToProps(dispatch, eventId),
    )(OrganizerHeader);

export default getConnectedOrganizerHeader;
